<template>
  <modal
    name="share-modal"
    :adaptive="true"
    :classes="['v--modal', 'share-modal']"
    height="auto"
    :max-width="370"
    @before-open="beforeOpen"
  >
    <div class="modal-content">
      <img
        :src="imageUrl"
        role="presentation"
        alt=""
      />
      <p class="title">
        {{ title }}
      </p>
      <p class="text">
        {{ text }}
      </p>
      <mastery-button
        v-if="canShare"
        :variant="'green'"
        @mastery-button-clicked="triggerShare()"
      >
        {{ buttonText }}
      </mastery-button>
      <share-box
        v-else
        :url="url"
      />
      <button
        class="cancel-button"
        @click="close"
      >
        Not Right Now
      </button>
      <input
        ref="textUrl"
        class="hidden-input"
        type="text"
        :value="url"
      />
    </div>
  </modal>
</template>

<script>
import MasteryButton from '@components/ui/masteryButton';
import ShareBox from '@/components/share/shareBox';

export default {
  components: { MasteryButton, ShareBox },
  computed: {
    buttonText() {
      if (this.config) {
        return this.config.button_text;
      }
    },
    canShare() {
      return navigator.share;
    },
    config() {
      return this.$store.getters['productVars/get']['homeShareMessage']?.parsedValue;
    },
    context() {
      return 'home';
    },
    imageUrl() {
      if (this.config) {
        const attachment = this.$store.getters['attachments/get'][this.config.attachment_id];
        return attachment?.url;
      }
    },
    url() {
      if (this.config) {
        let url = this.config.url;

        if (this.config.sc) {
          url += `?sc=${this.config.sc}`;
        }

        return url;
      }
    },
    text() {
      if (this.config) {
        if (this.canShare) {
          return this.config.text;
        } else {
          return this.config.web_copy_text || this.config.text;
        }
      }
    },
    title() {
      if (this.config) {
        return this.config.title;
      }
    },
  },
  created() {
    if (this.config?.attachment_id) {
      this.$store.dispatch('attachments/fetch', { ids: [this.config.attachment_id ]});
    }
  },
  methods: {
    beforeOpen() {
      this.$store.dispatch('session/updateUser', {
        lastShownShareMessage: Date.now(),
      });
      const params = {
        title: this.title,
        text: this.text,
        type: 'Share',
      };
      this.$analytics.events.viewedModal(params);
    },
    close() {
      this.$modal.hide('share-modal');
    },
    triggerShare() {
      const params = {
        Location: 'Refer Message',
      };

      if (navigator.share) {
        this.$analytics.events.sharedAsset(params);
        navigator.share({
          text: this.config?.message_text,
          url: this.url,
        }).catch(e => {
          if (e?.status === 'rejected') {
            const textInput = this.$refs.textUrl;
            textInput.select();
            textInput.setSelectionRange(0, 99999); // for mobile devices
            document.execCommand('copy');

            this.$notify({
              group: 'notifications',
              text: 'Share URL copied!',
              type: 'success',
            });
          }
        });
      } else {
        this.popoverOpen = true;
        this.$analytics.events.copiedShareLink(params);
      }
    },
  },
};
</script>

<style lang="scss">
.v--modal-overlay[data-modal="share-modal"] {
  background: rgba(0, 0, 0, .90);

  .v--modal {
    background: white;
    border-radius: 4px;
    box-shadow: none;
    padding: rem-calc(28);
  }
}

.share-modal {
  $success-green: #00b46d;
  display: flex;
  align-items: center;
  justify-content: center;

  .modal-content {
    max-width: rem-calc(376);
    text-align: center;
    line-height: 1.5;

    .title {
      font-size: rem-calc(26);
      font-weight: $bold;
      line-height: 1.23;
      margin-bottom: 0;
    }

    .text {
      margin-top: rem-calc(4);
    }

    img {
      max-width: 75%;
    }

    .cancel-button {
      background: transparent;
      display: block;
      font-size: rem-calc(11);
      margin: rem-calc(24) auto 0 auto;

      &:hover {
        text-decoration: underline;
      }
    }

    .hidden-input {
      display: none;
    }
  }

}
</style>
